import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { BackupStorageDeviceDTO } from 'src/app/model/backup-storage-device-dto';
import { BackupService } from 'src/app/services/backup.service';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { EditBackupDeviceComponent } from '../../modal/edit-backup-device/edit-backup-device/edit-backup-device.component';
import { getDeviceTypeString } from 'src/app/model/backup-device-type';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-backup-devices',
  templateUrl: './backup-devices.component.html',
  styleUrl: './backup-devices.component.scss',
})
export class BackupDevicesComponent implements OnInit {
  public backupDevices: BackupStorageDeviceDTO[] | undefined;
  private working: boolean = false;

  constructor(
    public backupService: BackupService,
    public dialog: MatDialog,
    private readonly loadIndicatorService: LoadIndicatorService,
    private readonly toastr: ToastrService,
  ) {
    AppComponent.updateAppHeader('storage devices', 'backups');
  }

  ngOnInit(): void {
    this.getBackupDevices();
  }

  getBackupDevices() {
    this.backupDevices = [];
    this.backupService
      .getBackupDevices()
      .then((response) => {
        this.backupDevices = response.items;
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  addDevice(): void {
    this.editDevice(undefined);
  }

  actionPending(): boolean {
    return this.working;
  }

  editDevice(device: BackupStorageDeviceDTO | undefined) {
    const dialogRef = this.dialog.open(EditBackupDeviceComponent, {
      data: device,
    });

    dialogRef.afterClosed().subscribe((reload) => {
      if (reload === true) {
        this.getBackupDevices();
      }
    });
  }

  getDeviceTypeString(deviceType?: number) {
    return getDeviceTypeString(deviceType);
  }

  public deleteDevice(device: BackupStorageDeviceDTO) {
    this.working = true;

    let message = 'Do you want to delete this device?';

    if (device.schedules?.length != 0) {
      message += ` All backup schedules will be deleted too.<br>Schedules: ${device.schedules?.map((sch) => sch.name).join(', ')}`;
    }

    this.dialog
      .open(ConfirmationDialogComponent, {
        data: message,
      })
      .afterClosed()
      .subscribe((response) => {
        if (response === true && device?.id != null) {
          this.backupService
            .deleteBackupDevice(device.id)
            .then((response) => {
              this.toastr.success('Device removed!');
              this.getBackupDevices();
            })
            .catch((error) => {
              this.toastr.error('Error removing this device.');
            })
            .finally(() => {
              this.working = false;
            });
        } else {
          this.working = false;
        }
      });
  }
}
